export default class Pathology {
  constructor (id, name, displayKey, entries, immunizations = [], recommendations = [], plannedShots = []) {
    this._id = id
    this._name = name
    this._displayKey = displayKey
    this._entries = entries
    this._immunizations = immunizations
    this._recommendations = recommendations
    this._plannedShots = plannedShots
  }

  get id () {
    return this._id
  }

  get name () {
    return this._name
  }

  get displayKey () {
    return this._displayKey
  }

  get entries () {
    return this._entries
  }

  get immunizations () {
    return this._immunizations
  }

  set immunizations (value) {
    this._immunizations = value
  }

  get recommendations () {
    return this._recommendations
  }

  set recommendations (value) {
    this._recommendations = value
  }

  get plannedShots () {
    return this._plannedShots
  }

  set plannedShots (value) {
    this._plannedShots = value
  }

  addImmunization (immunization) {
    this._immunizations.push(immunization)
  }

  addRecommendation (recommendation) {
    this._recommendations.push(recommendation)
  }

  addPlannedShot (shot) {
    this._plannedShots.push(shot)
  }

  getTotalShots () {
    return this._entries.length
  }

  hasElements () {
    return !!(this._plannedShots + this._immunizations + this._recommendations)
  }
}
